module.exports = __webpack_public_path__ + "img/Cr.5feee338.svg";